import API from "../utils/axios";

export function listSpecialities() {
  return API.get("/specialities");
};

export default {
  listSpecialities,
};
